<template>

  <!-- <nav class="teacher-topbar bg-primary"> -->
  <nav>
    <div class="container-fluid">
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <div class="site_logo">
          <h1>
            <router-link to="/teacher-dashboard" class="navbar-brand">
              {{ Lang.get('messages.site_name') }}
            </router-link>
          </h1>
        </div>
        <div class="site_setting">
          <ul class="navbar setting-list">

            <li class="nav-item">
              <div class="lang-blk">
                <button type="button" class="btn btn-link d-flex align-items-center border-left border-right-0"
                  v-if="Lang.getLocale() == 'ar'" @click="setLocale('en')"><i class="fas fa-globe mx-2"></i>
                  <span>En</span></button>
                <button type="button" class="btn btn-link d-flex align-items-center border-right"
                  v-if="Lang.getLocale() == 'en'" @click="setLocale('ar')"><i class="fas fa-globe mx-2"></i>
                  <span>AR</span></button>
              </div>
            </li>

            <li class="nav-item notification dropdown" v-if="isTeacher || isHodAsTeacher">
              <a class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                <!-- <img src="assets/images/alarm.png" data-src="assets/images/alarm.png" class="lazyload"> -->
                <i class="fab fa-facebook-messenger"></i>
                <span class="badge" v-if="isTeacher && notifications.length">
                  {{ notifications.length }}
                </span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                <template v-if="isTeacher">
                  <router-link :to="{
                    name: 'messenger',
                    params: {
                      class_id: _.get(getParentClass(notification.sender.classes), 'id'),
                      user_id: notification.sender.id,
                    }
                  }" class="dropdown-item" v-for="(notification, index) in notifications"
                    :key="index">
                    <strong>({{ _.get(getParentClass(notification.sender.classes), 'name') }})</strong>
                    <br />
                    {{ Lang.get('messages.new_message_from') }}
                    {{ notification.sender?.parent?.name }}
                  </router-link>

                  <div class="dropdown-divider" v-if="notifications.length"></div>
                </template>

                <router-link :to="{ name: 'messenger' }" class="dropdown-item">
                  {{ Lang.get('messages.open_messenger') }}
                </router-link>

              </div>
            </li>

            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                {{ user.name }}
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link to="profile" class="dropdown-item">
                  {{ Lang.get('messages.profile') }}
                </router-link>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" @click.prevent="logout">
                  {{ Lang.get('messages.logout') }}
                  <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                </a>
              </div>
            </li>

            <li class="nav-item btn btn-warning btn-sm" v-if="isHodAsTeacher">
              <a @click="backToHOD">
                {{ Lang.get('messages.back_to_HOD_dashboard') }}
              </a>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </nav>

</template>

<script>
import eBus from '@/event-bus';
import StorageService from '@services/storage.service';
import ApiService from "@services/api.service";
import Messenger from "@api/messenger.api";
import Classes from "@api/class.api";

import {
  mapState,
} from 'vuex';

export default {
  data() {
    return {
      notifications: [],
      teacherClasses: [],
      subscriptions: {},
      isHodAsTeacher: false,
    }
  },

  computed: {
    ...mapState("users", ["user"]),

    notificationChannelName() {
      return `notification.user.${this.user.id}`;
    },

    isTeacher() {
      return this.hasRole(this.ROLES.TEACHERS);
    },

    teacherClassesIDs() {
      return this.teacherClasses.map(({
        id
      }) => id);
    },
  },

  created() {
    // Set locale according to school if exists
    let lang = StorageService.getItem('locale');

    if (!lang) {
      let langID = this.user.school.lang.id
      if (langID == 1) {
        lang = 'ar';
      } else {
        lang = 'en';
      }
    }

    this.setLocale(lang);

    if (this.isTeacher) {
      this.initMessenger();
      this.getTeacherClasses();
      this.getUnreadNotifications();
    }
  },

  mounted() {
    eBus.$on('hodAsTeacher', () => {
      this.isHodAsTeacher = true;
    });
  },

  methods: {
    logout() {
      document.cookie = 'access_token=; path=/; max-age=-1; SameSite=Lax';
      this.$store.dispatch("users/logout");
    },
    setLocale(lang) {
      console.log('Language changed to:', lang);
      this.saveLocale(lang);
      this.changeDir(lang);
    },
    saveLocale(lang) {
      this.Lang.setLocale(lang);
      ApiService.setHeader("SMS-Locale", lang);
      StorageService.saveItem('locale', lang);
    },
    changeDir(lang) {
      this.Lang.setLocale(lang);
      let htmlEl = document.getElementsByTagName('html')[0];
      if (lang === 'en') {
        htmlEl.dir = 'ltr';
      } else if (lang.startsWith('ar')) {
        // Force RTL for any Arabic dialect
        htmlEl.dir = 'rtl';
      }

      let bodyEl = document.getElementsByTagName('body')[0];
      if (lang.startsWith('ar')) {
        bodyEl.classList.add('body-rtl');
      } else {
        bodyEl.classList.remove('body-rtl');
      }

      let cssLink1 = document.head.querySelector("link[data-app='vuejs']");
      let path1 = cssLink1.href;
      let filename1 = path1.substring(path1.lastIndexOf('/') + 1);
      const targetLang = lang.startsWith('ar') ? 'ar' : 'en';
      cssLink1.href = cssLink1.href.replace(filename1, `app-${targetLang}.css`);

      let cssLink2 = document.head.querySelector("link[data-app='teacher']");
      if (cssLink2) {
        let path2 = cssLink2.href;
        let filename2 = path2.substring(path2.lastIndexOf('/') + 1);
        cssLink2.href = cssLink2.href.replace(filename2, `style-${targetLang}.css`);
      }
    },

    backToHOD() {
      this.isHodAsTeacher = false;
      StorageService.removeItem('teacher');
      this.$router.push('/hod-dashboard');
    },

    getTeacherClasses() {
      // Get classes for select
      Classes.list({
        page: 0,
        teacher: this.user.teacher.id,
      }).then(res => (this.teacherClasses = res.data.data));
    },

    getUnreadNotifications() {
      Messenger.getUnreadNotifications({
        scope: 'user.micro,parent.micro'
      })
        .then(res => {
          this.notifications = res.data.data;
        });
    },

    getParentClass(classes) {
      return classes.find(c => this.teacherClassesIDs.includes(_.get(c, 'id')));
    },

    initMessenger() {
      if (typeof Echo === 'undefined') {
        console.warn('⚠️ Laravel Echo is not defined. Real-time notifications are disabled.');
        return;
      }
      console.log('Started...');

      // Leave notification channel to prevent multiple event listeners
      Echo.leave(this.notificationChannelName);
      // Subscribe the user to his/her private channel
      Echo.private(this.notificationChannelName)
        .listen('.new.chat', (res) => {
          let chatData = res.data;

          // Subscribe the user to new chat private channel
          if (!_.has(this.subscriptions, chatData.channel.name)) {
            Echo.private(chatData.channel.name)
              .listen(`.new.message`, this.newMessageListener);

            // Add channel to subscriptions
            this.$set(this.subscriptions, chatData.channel.name, chatData.channel);
          }
        });
    },

    newMessageListener(res) {
      let messageData = res.data

      Messenger.getNotificationSender(messageData.from_user, {
        scope: 'user.micro,parent.micro'
      })
        .then(res => {
          let sender = res.data.data;
          // Play sound
          new Audio('/sounds/pristine-609.mp3').play();
          this.$snotify.html(`<strong>${sender.parent.name}</strong> <p>${messageData.message}</p>`);

          if (this.notifications.some(n => n.sender.id == messageData.from_user)) {
            return false;
          }

          this.notifications.push({
            sender: sender
          });
        });
    },
  }
};
</script>

<style scoped>
.nav-link,
.lang-blk .btn-link {
  color: #FFF;
}

.nav-link:hover {
  color: #DDD;
}

.notification .nav-link {
  padding: 0.5rem 0 !important;
  font-size: .3rem;
}

.notification .dropdown-menu {
  left: auto;
  right: 0;
}

.fa-facebook-messenger {
  font-size: 1.4rem;
}
</style>